﻿import { Directive, Input, Output, EventEmitter, ElementRef, HostListener, OnInit, AfterViewInit, Renderer, OnDestroy } from '@angular/core';

@Directive({
    selector: '[do-focus]'
})
export class FocusDirective {

    @Input('do-focus') doFocus: boolean = true;
    private sortProperty: string;
    nativeElement: HTMLElement;

    constructor(private elRef: ElementRef, private renderer: Renderer) {
        this.nativeElement = this.elRef.nativeElement;
    }


    ngAfterViewInit() {

        if (this.doFocus !== false && !this.isTouchDevice()) {
            if (this.nativeElement.tagName === "USER-INPUT") {
                setTimeout(() => {
                    this.nativeElement.getElementsByTagName("input")[0].focus();
                })
            }
            else {
                this.nativeElement.focus();
            }
        }
    }

    isTouchDevice() {
        return 'ontouchstart' in window        // works on most browsers 
            || navigator.maxTouchPoints;       // works on IE10/11 and Surface
    };


}